class Scope {
    constructor(serverType) {
        this.serverType = serverType;
    }

    translate(t) {
        return t(`products.scope-value.${this.serverType.toLowerCase().replace(/_/g, '-')}`);
    }

    is(scope) {
        return scope === this;
    }
}

export const ETS1 = new Scope('ETS1');
export const ETS2 = new Scope('ETS2');
export const UNKNOWN = new Scope('null');

export const getScope = (serverType) => {
    let result;
    switch (serverType) {
        case 'ETS1':
            result = ETS1;
            break;
        case 'ETS2':
            result = ETS2;
            break;
        default:
            result = UNKNOWN;
    }
    return result;
};

export const getAllScopes = () => [
    ETS1,
    ETS2,
];
